export default __webpack_public_path__ + "static/media/wDress_1.415dc0f6.bin";